import { AnalysisMethod } from '@/api/domains/analyses/types';
import styles from '../ConfigurationForm.module.css';
import { getMethodInfo } from '../utils';

type PresetCardProps = {
  method: AnalysisMethod;
  active: boolean;
  onApply: (m: AnalysisMethod) => void;
  onInfo: (m: AnalysisMethod) => void;
};

export const PresetCard = ({
  method,
  active,
  onApply,
  onInfo
}: PresetCardProps) => {
  const info = getMethodInfo(method);
  return (
    <div className={styles.presetWrapper}>
      <div
        role="button"
        className={`${styles.presetCard} ${active ? styles.activePreset : ''}`}
        onClick={() => onApply(method)}
        onKeyDown={() => onApply(method)}
        tabIndex={0}
      >
        <i className={`pi ${info.icon} ${styles.presetIcon}`} />
        <div className={styles.presetText}>
          <h4>{info.title}</h4>
          <span className={styles.durationLabel}>{info.duration}</span>
        </div>
      </div>
      <i
        className={`pi pi-question-circle ${styles.infoIcon}`}
        onClick={() => onInfo(method)}
      />
    </div>
  );
};
